export type Theme = "system" | "light" | "dark";
const KEY = "codvero.theme";

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(t: Theme) {
  const dark = t === "dark" || (t === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  try {
    if (t === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {
    /* private mode */
  }
}

export function watchSystemTheme() {
  const mq = matchMedia("(prefers-color-scheme: dark)");
  const on = () => readTheme() === "system" && applyTheme("system");
  mq.addEventListener("change", on);
  return () => mq.removeEventListener("change", on);
}
